import { css } from 'lit';

export const style = css`
  .refi-error-container {
    margin: 2.5em 1em 0.5em;
    text-align: center;
  }

  @media (min-width: 48em) {
    .refi-error-container {
      margin: 2.5em auto 0.5em;
      max-width: 30em;
    }
  }

  fs-heading {
    margin-bottom: 2rem;
  }

  .refi-error-button {
    margin: 2em auto 2em;
  }
`;
